<a class="button"
    :class="[type === 'secondary' ? 'button--secondary' : 'button--primary']"
    :href="href"
    :target="target"
    v-html="text"
></a>